import { useState, useEffect } from 'react'
import { Markdown } from '@wair/markdown'

const FileRenderer = ({ fileUrl }: any) => {
  const [fileContent, setFileContent] = useState<any>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(fileUrl)
        const data = await response.text()
        console.log('data =>', data)
        setFileContent(data)
      } catch (error) {
        console.error('Error fetching file:', error)
      }
    }

    fetchData()
  }, [fileUrl])

  return (
    <Markdown
      content={fileContent || ''}
      className="px-12 py-6 overflow-auto"
    />
  )
}

export default FileRenderer
